//引用 from https://orange-factory.com/tool/kanjicheck.html
const hisshu = {
	'1':'一右雨円王音下火花貝学気九休玉金空月犬見五口校左三山子四糸字耳七車手十出女小上森人水正生青夕石赤千川先早草足村大男竹中虫町天田土二日入年白八百文木本名目立力林六',
	'2':'引羽雲園遠何科夏家歌画回会海絵外角楽活間丸岩顔汽記帰弓牛魚京強教近兄形計元言原戸古午後語工公広交光考行高黄合谷国黒今才細作算止市矢姉思紙寺自時室社弱首秋週春書少場色食心新親図数西声星晴切雪船線前組走多太体台地池知茶昼長鳥朝直通弟店点電刀冬当東答頭同道読内南肉馬売買麦半番父風分聞米歩母方北毎妹万明鳴毛門夜野友用曜来里理話',
	'3':'悪安暗医委意育員院飲運泳駅央横屋温化荷界開階寒感漢館岸起期客究急級宮球去橋業曲局銀区苦具君係軽血決研県庫湖向幸港号根祭皿仕死使始指歯詩次事持式実写者主守取酒受州拾終習集住重宿所暑助昭消商章勝乗植申身神真深進世整昔全相送想息速族他打対待代第題炭短談着注柱丁帳調追定庭笛鉄転都度投豆島湯登等動童農波配倍箱畑発反坂板皮悲美鼻筆氷表秒病品負部服福物平返勉放味命面問役薬由油有遊予羊洋葉陽様落流旅両緑礼列練路和',
	'4':'愛案以衣位茨印英栄媛塩岡億加果貨課芽賀改械害街各覚潟完官管関観願岐希季旗器機議求泣給挙漁共協鏡競極熊訓軍郡群径景芸欠結建健験固功好香候康佐差菜最埼材崎昨札刷察参産散残氏司試児治滋辞鹿失借種周祝順初松笑唱焼照城縄臣信井成省清静席積折節説浅戦選然争倉巣束側続卒孫帯隊達単置仲沖兆低底的典伝徒努灯働特徳栃奈梨熱念敗梅博阪飯飛必票標不夫付府阜富副兵別辺変便包法望牧末満未民無約勇要養浴利陸良料量輪類令冷例連老労録',
	'5':'圧囲移因永営衛易益液演応往桜可仮価河過快解格確額刊幹慣眼紀基寄規喜技義逆久旧救居許境均禁句型経潔件険検限現減故個護効厚耕航鉱構興講告混査再災妻採際在財罪殺雑酸賛士支史志枝師資飼示似識質舎謝授修述術準序招証象賞条状常情織職制性政勢精製税責績接設絶祖素総造像増則測属率損貸態団断築貯張停提程適統堂銅導得毒独任燃能破犯判版比肥非費備評貧布婦武復複仏粉編弁保墓報豊防貿暴脈務夢迷綿輸余容略留領歴',
	'6':'胃異遺域宇映延沿恩我灰拡革閣割株干巻看簡危机揮貴疑吸供胸郷勤筋系敬警劇激穴券絹権憲源厳己呼誤后孝皇紅降鋼刻穀骨困砂座済裁策冊蚕至私姿視詞誌磁射捨尺若樹収宗就衆従縦縮熟純処署諸除承将傷障蒸針仁垂推寸盛聖誠舌宣専泉洗染銭善奏窓創装層操蔵臓存尊退宅担探誕段暖値宙忠著庁頂腸潮賃痛敵展討党糖届難乳認納脳派拝背肺俳班晩否批秘俵腹奮並陛閉片補暮宝訪亡忘棒枚幕密盟模訳郵優預幼欲翌乱卵覧裏律臨朗論'
}
// 漢字（Unicode的に言うCJK統合漢字の範囲）を表す正規表現
const kanji = new RegExp(/[\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff]/)

// 赤字の個数をカウント
let count = 0

// チェック関数
exports.check = (text) => {

  // ok = 指定された学年までに習う漢字
  let ok = "";

  // limit = N年生までに習う漢字
  const limit = 6

  // 各学年のデータを連結した文字列を作る
  for (let i = 1; i <= limit; i++) {
    ok += hisshu[i]
  }

  // チェック対象テキスト取得
  text = text.replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;')

  // 結果格納用
  let result = ""
  let judge = ""

  // チェック対象を1文字ずつ確認しながら、resultに投入
  let chars = text.split('');
  for (let i = 0; i < chars.length; i++) {
    let c = chars[i]
    // 漢字だったら
    if (c.match(kanji)) {
      // 習ってる
      if (ok.match(c)) {
        result += c
      }
      // 習ってない
      else {
        result += '<span class = "red">' + c + '</span>'
        count++
      }
    }
    else {
      result += c
    }
  }

  // チェック基準変えている場合は、結果の末尾に注釈つける
  if(count > 0){
    judge += '<span style="color:gray">（小学校6年生までに習っていないものは赤字で示してあります。）</span>'
  }else{
    judge += '<span style="color:gray">（この中に小学校で未習得の漢字はありません。👍)</span>'
  }

  //次回実行時用にカウントをリセット
  count = 0

  // 結果を画面に表示
  result = result.replace(/\n/g, '<br />')
  return [result,judge]
}
